import styles from './NavButton.module.css';

const NavButton = ({ text, size, style, onClick }) => {
  const sizeClass = size === 'large' ? styles.large : styles.small;

  const classNames = `${styles.button} ${sizeClass}`;

  return (
    <div className={classNames} style={style} onClick={onClick}>
      {text}
    </div>
  );
};

export default NavButton;
